/**
 * Shared rules for "merchant wrap-up" vs "agent still working".
 * Keep in sync with papaya/src/crons/scheduledTaskSummaryHeuristics.ts
 * (separate packages; no shared runtime).
 *
 * Task-agnostic: do not key off sheet sync, ads, Slack, etc.
 */

/** Markdown structure any scheduled-task wrap-up can use. */
export function looksLikeStructuredReport(text: string): boolean {
  const t = text.trim()
  if (!t) return false
  if (/^#{1,3}\s+\S/m.test(t)) return true
  if (/^\|.+\|/m.test(t) && /\|[-: ]+\|/m.test(t)) return true
  if (t.length > 180 && /^\s*(?:[-*]|\d+[.)])\s+\S/m.test(t) && t.includes('\n')) return true
  return false
}

/**
 * Mid-run paging / plan notes — not a finished report.
 * Only paging markers and "fetch the next page/batch" language; length is not a signal.
 */
export function looksLikeProgressNote(text: string): boolean {
  const t = text.trim()
  if (!t) return true
  if (looksLikeStructuredReport(t)) return false

  if (/\b(?:offset|limit|has_more|next_offset|page_token)\s*=/i.test(t)) return true
  if (/rows?\s+\d+\s*[–—-]\s*\d+/i.test(t)) return true
  if (/\bfetching\s+(?:the\s+)?(?:next|final|remaining|\bpage\s+\d+)\b/i.test(t)) return true
  if (
    /\bI[‘’]ll\s+(?:import|read|fetch|continue|load|query|pull)\s+(?:the\s+)?(?:first|next|current|remaining)\s+(?:batch|page)\b/i.test(
      t,
    )
  ) {
    return true
  }
  if (/\bmore\s+rows?\s+remain\b/i.test(t)) return true
  if (/\bnow\s+I[‘’]ll\b/i.test(t) && /\bbatch\b/i.test(t)) return true
  if (/\bpage\s+\d+\s+imported\b/i.test(t)) return true
  if (/\b(?:import|fetch|read|pull|load)\s+(?:the\s+)?(?:next\s+)?page\s+\d+\b/i.test(t)) return true
  return false
}
